import CachedRoundedIcon from "@mui/icons-material/CachedRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { Box, IconButton, Tooltip } from "@mui/material";
import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePanel } from "../../../../store/contexts/DashBoardPannelContext";
import ExecutionsModal from "./ExecutionsModal";

const translationPath = "page.panels.";

const EXECUTIONS_PARAM = "executions";

export const Refresh = memo(() => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const [modalOpen, setModalOpen] = useState(
    searchParams.get(EXECUTIONS_PARAM) === "1",
  );

  const { panel, fetchPanel, fetchDashboards } = usePanel();

  const refreshHandler = useCallback(() => {
    fetchPanel();
    fetchDashboards();
  }, [fetchPanel, fetchDashboards]);

  const closeModalHandler = useCallback(() => {
    setModalOpen(false);
    setSearchParams(
      (prev) => {
        prev.delete(EXECUTIONS_PARAM);
        return prev;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  const openDetailHandler = useCallback(
    (executionId: string) => {
      setSearchParams(
        (prev) => {
          prev.set(EXECUTIONS_PARAM, "1");
          return prev;
        },
        { replace: true },
      );
      navigate(`../executions/${executionId}`);
    },
    [navigate, setSearchParams],
  );

  return (
    <Box sx={{ display: "flex" }}>
      <Tooltip title={t(translationPath + "sync_tooltip")}>
        <IconButton onClick={() => setModalOpen(true)}>
          <CachedRoundedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t(translationPath + "refresh_tooltip")}>
        <IconButton sx={{ minWidth: 40 }} onClick={refreshHandler}>
          <RefreshRoundedIcon />
        </IconButton>
      </Tooltip>
      {modalOpen && (
        <ExecutionsModal
          open={modalOpen}
          dashboardPanelId={panel.id}
          onClose={closeModalHandler}
          onOpenDetail={openDetailHandler}
        />
      )}
    </Box>
  );
});
